<template>
  <div :class="[className ? className : '', sliderDownload ? 'preview--width': '', 'preview']" :id="id ? 'hidden-block-for-screenshoot' : ''">
    <BaseLazyImage class="preview__wall" :src="getInteriorActive" />
    <SliderWindows />
    <SliderModels
      :materials="materials"
      :materialsItem="materialsItem"
    />
    <SliderInfo
      v-show="(panelInfo || sliderDownload) && getModel"
      :materialsItem="materialsItem"
      :panelShow="panelInfo" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'SliderHiddenBlock',

  components: {
    BaseLazyImage: () => import('@/components/base/BaseLazyImage'),
    SliderWindows: () => import('./SliderWindows'),
    SliderModels: () => import('./SliderModels'),
    SliderInfo: () => import('./SliderInfo'),
  },

  props: {
    className: String,
    id: {
      type: Boolean,
      default: false,
    },
    panelInfo: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    ...mapState({
      interiorActive: state => state.slider.interiorActive,
      models: state => state.models.models,
      materials: state => state.models.materials,
      materialsItem: state => state.models.materialsItem,
      sliderDownload: state => state.slider.sliderDownload,
    }),

    ...mapGetters("models", [
      "getModel",
    ]),

    ...mapGetters('slider', ['getInteriorActive'])
  },
};
</script>

<style scoped lang="scss">
.preview {
  position: absolute;
  right: 20px;
  top: 0;
  line-height: 0;
  width: 540px;
  height: 335px;
  display: block;
  overflow: hidden;
  z-index: 1;

  &--width {
    width: calc(100% - 460px);
    height: auto;

    @media(max-width: $desktop) {
      width: 100%;
    }
  }

  @media(max-width: $desktop) {
    top: 45px;

    &--static {
      position: relative;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;

      .preview__wall {
        height: 100%;
        width: auto;
        max-width: inherit;
      }
    }
  }

  &__wall {
    width: 100%;
    height: auto;
  }
}
</style>
